import { useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import { Stack } from "@mui/material";
import { Strategy } from "../../../store/slices/strategySlice";
import CustomPaper from "../../../_components/CustomPaper";
import {ButtonStyled} from "../../../_components/ButtonStyled";
import IconComponent from "../../../_components/IconComponent";
import AdronTypography from "../../../_components/AdronTypography";

interface Props {
  step: number;
  onChangeStep: (step: number) => void;
  strategy: Strategy;
  showPreview: (value: boolean) => void;
  editing: boolean;
}

const AutoStrategyPagination = ({ step, onChangeStep, strategy, showPreview, editing }: Props) => {
  const theme = useTheme();

  const buttonStyle = {
    display: "flex",
    padding: "7px 15px",
    width: "100%",
  };

  const filledFirstStepFields = useMemo(() => {
    if (strategy.minPrice === 0 || strategy.maxPrice === 0) {
      return true;
    } else {
      return false;
    }
  }, [strategy.minPrice, strategy.maxPrice]);

  const handleDecreaseStep = () => onChangeStep(step - 1);
  const handleIncreaseStep = () => onChangeStep(step + 1);

  const handleToPreview = () => showPreview(true);

  return (
    <CustomPaper
      sx={{
        backgroundColor: theme.palette.background.paper + "!important",
        borderRadius: "12px !important",
      }}
    >
      <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={1}>
        <ButtonStyled
          onClick={step > 1 ? handleDecreaseStep : undefined}
          style={{ opacity: 0.5, ...buttonStyle }}
          fullWidth={true}
          color={"secondary"}
          variant="text"
          startIcon={<IconComponent iconName={"ChevronLeft"} hasStroke hasFill />}
        >
          Back
        </ButtonStyled>
        <AdronTypography
          style={{ width: "100%", textAlign: "center" }}
          halfOpacity
          value={`Step ${step} of  3`}
        />
        {step === 3 ? (
          <ButtonStyled
            onClick={handleToPreview}
            style={{ padding: "8px 16px", color: "#fff" }}
            fullWidth={true}
            color={"primary"}
            variant="contained"
          >
            Preview
          </ButtonStyled>
        ) : (
          <ButtonStyled
            onClick={step < 3 ? handleIncreaseStep : undefined}
            style={buttonStyle}
            disabled={filledFirstStepFields}
            fullWidth={true}
            color={"secondary"}
            variant="outlined"
            endIcon={<IconComponent iconName={"ChevronRight"} hasStroke />}
          >
            Next
          </ButtonStyled>
        )}
      </Stack>
    </CustomPaper>
  );
};

export default AutoStrategyPagination;
